module.exports = __webpack_public_path__ + "d0db145c0c4d3e301355c52ce08c07eb.png";